import { mapGetters, mapActions, mapMutations } from "vuex";
import VueRangeSlider from "vue-range-component";

import CategorySelect from "../select/index.vue";
import _ from "lodash";
import "vue-range-component/dist/vue-range-slider.css";

export default {
    name: "category-filter",
    data() {
        return {
            selectedFilters: [],
            value: [],
            minPrice: 0,
            maxPrice: 0,
        };
    },
    components: {
        CategorySelect,
        VueRangeSlider,
    },
    created() {
        this.value = [];
        this.enableCross = false;
        this.tooltipMerge = false;
        this.formatter = value => `₴${value}`;
        this.processStyle = {
            backgroundColor: "#004AAD",
        };
        this.tooltipStyle = {
            backgroundColor: "#004AAD",
            borderColor: "#004AAD",
        };
        this.bgStyle = {
            backgroundColor: "#5B99EB",
            boxShadow: "inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)",
        };
        let obj = {};
        if (this.$route.params.filterSlug) {
            let slugFilter = this.findFilterSlug(this.$route.params.filterSlug);
            obj = {
                [slugFilter]: [this.$route.params.filterSlug],
            };
        }

        for (const i in this.$route.query) {
            if (typeof this.$route.query[i] === "string") {
                obj[i] = this.$route.query[i].split(" ");
            } else {
                obj = this.$route.query;
            }
        }

        // this.fetchList({
        //     categorySlug: this.$route.params.categorySlug ? this.$route.params.categorySlug : 'all',
        //     data: {'attributes': obj}
        // }).then((res) => {
        //     this.minPrice = null
        //     this.maxPrice = null
        //     this.minPrice = this.filterCategories?.price.min
        //     this.maxPrice = this.filterCategories?.price.max
        //     this.value = []
        //     this.value.push(this.filterCategories?.price.min)
        //     this.value.push(this.filterCategories?.price.max)
        // })
    },
    watch: {
        $route() {
            this.updateRouter();
        },
    },

    computed: {
        ...mapGetters({
            filterCategories: "setting/filterCategories",
            filterCategoriesLoading: "setting/filterCategoriesLoading",
            showFilter: "system/showFilter",
            childCategoryList: "category/getters",
        }),
    },
    methods: {
        ...mapActions({
            fetchList: `category/GET_FILTER_PRODUCTS_LIST`,
        }),
        ...mapMutations({
            removeFilterItem: `category/REMOVE_FILTER_ITEM_IN_SEARCH`,
            changeOpenFilter: `system/CHANGE_OPEN_FILTER`,
        }),
        showSelected() {
            this.sortPriceRange();
            this.changeOpenFilter(false);
            window.scrollTo(0, 0);
        },
        findFilterSlug(input) {
            for (let attribute of this.filterCategories.attributes) {
                for (let value of attribute.values) {
                    if (value.slug === input) {
                        return attribute.slug;
                    }
                }
            }
            return null;
        },
        sortPriceRange() {
            let obj = {};
            for (const i in this.$route.query) {
                if (typeof this.$route.query[i] === "string") {
                    obj[i] = this.$route.query[i].split(" ");
                } else {
                    obj = this.$route.query;
                }
            }
            if (this.typeSort) {
                this.fetchList({
                    categorySlug: this.$route.params.categorySlug ? this.$route.params.categorySlug : "all",
                    data: { attributes: obj },
                    sort: "ASC",
                    min: this.value[0],
                    max: this.value[1],
                });
            } else {
                this.fetchList({
                    categorySlug: this.$route.params.categorySlug ? this.$route.params.categorySlug : "all",
                    data: { attributes: obj },
                    sort: "DESC",
                    min: this.value[0],
                    max: this.value[1],
                });
            }
        },
        updateRouter() {
            const query = this.$route.query;
            let currentCategories = [];

            let arr = [];
            currentCategories.forEach(e => {
                e.values.forEach(t => {
                    for (let i in query) {
                        let currentQuery = query[i];
                        if (!Array.isArray(currentQuery)) {
                            currentQuery = [];
                            currentQuery.push(query[i]);
                        }

                        currentQuery.forEach(c => {
                            if (t.slug === c) {
                                const elem = _.find(arr, ["slug", e.slug]);
                                if (elem) {
                                    elem.categories.push(t);
                                } else {
                                    arr.push({
                                        name: e.name,
                                        slug: e.slug,
                                        categories: [t],
                                    });
                                }
                            }
                        });
                    }
                });
            });
            this.selectedFilters = arr;
        },
        reset() {
            this.$router.push({
                name: "categories",
                params: { slug: this.$route.params.slug },
            });
            this.fetchList({ categorySlug: this.$route.params.categorySlug, data: { attributes: this.$route.query } });
        },
    },
};
